import { render, staticRenderFns } from "./wellveLogo.vue?vue&type=template&id=3df52884&lang=pug&"
import script from "./wellveLogo.vue?vue&type=script&lang=js&"
export * from "./wellveLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports